import allOrdersSelectorDefinition from './all.js'
import getIsExchangeTxSelectorDefinition from './get-is-exchange-tx.js'
import ordersInProgressSelectorDefinition from './orders-in-progress.js'
import assetIncomingOrdersSelectorDefinition from './asset-incoming-orders.js'
import potentialCompleteOrders from './potential-complete-orders.js'
import createOrdersInAccountSelectorDefinition from './create-orders-in-account.js'
import ordersInActiveAccountSelectorDefinition from './orders-in-active-account.js'
import createAssetSourceIncomingOrdersSelectorDefinition from './create-asset-source-incoming-orders.js'
import createAssetSourceIncomingOrdersAmountSelectorDefinition from './create-asset-source-incoming-orders-amount.js'
import createAssetIncomingOrdersAmountSelectorDefinition from './create-asset-incoming-orders-amount.js'
import createAssetsHaveIncomingOrdersSelectorDefinition from './create-assets-have-incoming-orders.js'

export default [
  allOrdersSelectorDefinition,
  getIsExchangeTxSelectorDefinition,
  ordersInProgressSelectorDefinition,
  assetIncomingOrdersSelectorDefinition,
  potentialCompleteOrders,
  createOrdersInAccountSelectorDefinition,
  ordersInActiveAccountSelectorDefinition,
  createAssetSourceIncomingOrdersSelectorDefinition,
  createAssetSourceIncomingOrdersAmountSelectorDefinition,
  createAssetIncomingOrdersAmountSelectorDefinition,
  createAssetsHaveIncomingOrdersSelectorDefinition,
]
